import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { ActionColumn } from "./model/actionColumn";
import { CommonModule } from "@angular/common";
import { IconComponent } from "../../../icon/icon.component";

@Component({
  selector: "rfc-action-column",
  templateUrl: "./action-column.component.html",
  styleUrls: ["./action-column.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    IconComponent
  ]
})
export class ActionColumnComponent {
  @Input() actions: Array<ActionColumn>;
  @Input() navigationState: boolean;

  @Output() onClickEventEmitted = new EventEmitter();
  @Output() navigateWithState = new EventEmitter();
  constructor(private route: Router) {}

  navigate(path) {
    this.onClickEventEmitted.emit(true);
    if(path){
      if(this.navigationState){
        this.navigateWithState.emit(path)
      } else {
        this.route.navigate([path])
      }
    }
  }
}
